module.exports = __webpack_public_path__ + "img/qr-code-suzhou.7eba203e.jpg";